// DS: i12.7
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioAnalytics: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
        <path d="M25.436 5.005a1 1 0 0 1 .898.995v20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V6l.004-.103A1 1 0 0 1 7.333 5h18zM8.334 25h16V7h-16zm12.801-13.195a1 1 0 0 1 .898.995v2.1a1 1 0 0 1-1.942.337l-3.194 3.356a1.2 1.2 0 0 1-1.616.111l-.093-.082-.903-.886-2.516 2.74a1 1 0 0 1-1.473-1.353l3.075-3.348.09-.088a1.2 1.2 0 0 1 1.54-.04l.093.083.913.895 2.692-2.826a1 1 0 0 1 .012-2h2.322z"></path>
      </svg>
    </IconWrap>
  );
};
StudioAnalytics.displayName = 'StudioAnalytics';

export default StudioAnalytics;
